import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApiResponse,
  MiddleMileDownloadResponse,
  MiddleMileUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { MiddleMileResponse } from "../../models/responseModels/middleMileResponse";
import { UpdateMiddleMileRequest } from "../../models/requestModels/updateMiddleMileRequest";

type InitialState = {
  isLoading: boolean;
  middleMileList: MiddleMileResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  middleMileList: [],
  errorMessage: null,
};

export const getMiddleMileList = createAsyncThunk<MiddleMileUIResponse>(
  "middleMile/MiddleMileResponse",
  async () => {
    const response = await agent.MiddleMileAgent.getMiddleMileList();
    return response;
  }
);

export const downloadMiddleMileDataToCsv = createAsyncThunk<
  MiddleMileDownloadResponse,
  MiddleMileResponse[]
>("middleMile/downloadCsv", async (middleMilesData: MiddleMileResponse[]) => {
  const response = await agent.MiddleMileAgent.middleMileCsvDownload(
    middleMilesData
  );
  return response;
});

export const downloadMiddleMileDataToXlsx = createAsyncThunk<
  Blob,
  MiddleMileResponse[]
>("middleMile/downloadXlsx", async (middleMilesData: MiddleMileResponse[]) => {
  const response = await agent.MiddleMileAgent.middleMileXlsxDownload(
    middleMilesData
  );
  return response;
});

export const updateMiddleMile = createAsyncThunk<
  ApiResponse,
  UpdateMiddleMileRequest
>(
  "receiving/processBarcode",
  async (processBarcodeRequest: UpdateMiddleMileRequest) => {
    const response = await agent.MiddleMileAgent.updateMiddleMile(
      processBarcodeRequest
    );
    return response;
  }
);

const middleMileSlice = createSlice({
  name: "middleMile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMiddleMileList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMiddleMileList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.middleMileList = action.payload.data;
        } else {
          state.middleMileList = [];
        }
      })
      .addCase(getMiddleMileList.rejected, (state, action) => {
        state.isLoading = false;
        state.middleMileList = [];
        state.errorMessage = action.error.message!;
      })
      .addCase(downloadMiddleMileDataToCsv.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadMiddleMileDataToCsv.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadMiddleMileDataToCsv.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message!;
      })
      .addCase(downloadMiddleMileDataToXlsx.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(downloadMiddleMileDataToXlsx.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(downloadMiddleMileDataToXlsx.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message!;
      });
  },
});

export default middleMileSlice.reducer;
